export default __webpack_public_path__ + "media/images/admin/spinner-7e0cb4cdd1067e7afb60ada57bd8aabb.svg";